<div class="content" role="main">

  <h2> {{basicSearch ? "Basic Search" : "Complex Search"}}</h2>
  <p>Retrieve product data from the cosmethics database based on a {{basicSearch ? "Time Range, EANs, Categories, Brands or Region" : "Time Range, EANs, Categories, Brands, Region, Specific ingredients or Certificates"}}</p>

  <form class="forms widthMax" [formGroup]="getProductsDataForm" (ngSubmit)="onSubmit()">


<!--    <mat-slide-toggle class="margin" (toggleChange)="switchView()">  {{ basicSearch ? 'Switch to complex search' : 'Switch to basic search' }} </mat-slide-toggle>-->

    <div id="buttons">
      <div class="buttonHint" *ngIf="!basicSearch" >
        <button mat-raised-button color="primary" (click)="switchView()" >Basic Search</button>
        <mat-hint> Do you wish to filter your product search based on Time Range, EANs, Categories, Brands or Region only</mat-hint>
      </div>
      <div class="buttonHint" *ngIf="basicSearch" >
        <button mat-raised-button color="primary" (click)="switchView()" >Complex Search</button>
        <mat-hint> Do you wish to filter your product search based on specific ingredients or certificates</mat-hint>
      </div>
    </div>

    <mat-accordion class="example-headers-align widthMax"  >

      <!-- ** Dates ** -->
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
        <!--        <ng-container *ngTemplateOutlet="matExpansionPanelHeader context: header"></ng-container>-->

        <mat-expansion-panel-header>
          <mat-panel-title>
            Dates
          </mat-panel-title>
          <mat-panel-description *ngIf="!getProductsDataForm.value.range.startDate && !getProductsDataForm.value.range.endDate else panelDescriptionDateSelected" >
            Select the range on which you want the products want to be from
          </mat-panel-description>
          <ng-template #panelDescriptionDateSelected>
            <mat-panel-description>
              <span class="title">Start </span> {{getProductsDataForm.value.range.startDate | date}}
              <span class="title">End </span> {{getProductsDataForm.value.range.endDate | date}}
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="spaceAround">
          <button mat-raised-button type="button" color="primary" (click)="selectFullRange()">Full range</button>
          <mat-form-field appearance="fill">
            <mat-label>Enter a specific date range</mat-label>
            <mat-date-range-input formGroupName="range" [rangePicker]="picker">
              <input matStartDate formControlName="startDate" placeholder="Start date">
              <input matEndDate formControlName="endDate" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <!--      <mat-error *ngIf="range.controls.startDate.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
            <!--      <mat-error *ngIf="range.controls.endDate.hasError('matEndDateInvalid')">Invalid endDate date</mat-error>-->
          </mat-form-field>
        </div>

        <ng-container *ngTemplateOutlet="matActionRow context:{firstStep:true, disabled:!getProductsDataForm.value.range.startDate && !getProductsDataForm.value.range.endDate}"></ng-container>

      </mat-expansion-panel>

      <!-- ** EANs ** -->
      <!-- [disabled]="step < 1 && !getProductsDataForm.value.range.startDate" [hideToggle]="step < 1 && !getProductsDataForm.value.range.startDate" -->
      <mat-expansion-panel [expanded]="step === 1"   (opened)="setStep(1)"  >
        <mat-expansion-panel-header>
          <mat-panel-title>
            EANs
          </mat-panel-title>
          <mat-panel-description *ngIf="!eanSelected else panelDescriptionEANsSelected" >
            Filter on specific EAN(s)
            <!--            <mat-icon>account_circle</mat-icon>-->
          </mat-panel-description>
          <ng-template #panelDescriptionEANsSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title">{{ getProductsDataForm.value.EANs.length > 0 ? getProductsDataForm.value.EANs.length < 5 ? getProductsDataForm.value.EANs.join(', ') : getProductsDataForm.value.EANs.length + " EANs selected" : "All EANs selected" }}</span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="selectAllEans()">Select All EANs</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListEANs>
            <ng-container *ngTemplateOutlet="chip context: eanChipElement"></ng-container>
            <input
              type="number"
              placeholder="Enter one or several EAN..."
              #eanInput
              [formControl]="eanCtrl"
              [matChipInputFor]="chipListEANs"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event, eanCtrl, eanChipElement.arrayString, eanChipElement.formArrayName, false)">
          </mat-chip-list>
        </mat-form-field>

        <div class="dragAndDrop" appDragAndDrop (fileDropped)="onFileDropped($event)" >
          <input type='file' #fileDrop id="fileDrop" accept='application/json' (change)="fileBrowseHandler($event.target.files)">
          <span> Drag and drop a list of EANs</span>
          <span> or</span>
          <label for="fileDrop" > Choose a file</label>
        </div>

        <p> Make sure the files are JSON files following this format : [ "ean1", "ean2", "ean3", ... ]</p>

        <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!eanSelected}"></ng-container>

      </mat-expansion-panel>

      <!-- ** Categories ** -->
      <!-- [disabled]="step < 2" [hideToggle]="step < 2" -->
      <mat-expansion-panel [expanded]="step === 2"   (opened)="setStep(2)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Categories
          </mat-panel-title>
          <mat-panel-description *ngIf="getProductsDataForm.value.categories.length == 0 else panelDescriptionCategoriesSelected" >
            Filter on specific Categories
          </mat-panel-description>
          <ng-template #panelDescriptionCategoriesSelected>
            <mat-panel-description id="categoriesSelection">
              <span class="title" *ngIf="allChecked(categories)"> All categories selected</span>
              <span class="title" *ngIf="someChecked(categories)"> Some categories selected</span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <button mat-raised-button type="button" color="primary" (click)="selectAllCategories()">Select All Categories</button>

        <div id="categories">

          <mat-expansion-panel *ngFor="let cat of categories; index as i" >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-checkbox class="example-margin"
                              (change)="onCategoriesChange(cat, $event)"
                              [checked]="allChecked(cat.subcategories)"
                              [indeterminate]="someChecked(cat.subcategories)">
                  {{cat.name}}
                </mat-checkbox>
              </mat-panel-title>
              <mat-panel-description *ngIf="!someChecked(cat.subcategories) && !allChecked(cat.subcategories) else panelDescriptionSubCategoriesSelected" >
                Click to see the subcategories
              </mat-panel-description>
              <ng-template #panelDescriptionSubCategoriesSelected>
                <mat-panel-description >
                  <span class="title" *ngIf="allChecked(cat.subcategories)"> All subcategories selected</span>
                  <span class="title" *ngIf="someChecked(cat.subcategories)"> Some subcategories selected</span>
                </mat-panel-description>
              </ng-template>
            </mat-expansion-panel-header>
            <span class="example-list-section">
                <ul class="checkboxes_lists">
                  <li *ngFor="let subcat of cat.subcategories">
                    <mat-checkbox (change)="onSubCategoriesChange(subcat,cat, $event)" [checked]="subcat.checked">
                      {{subcat.name}}
                    </mat-checkbox>
                  </li>
                </ul>
            </span>
          </mat-expansion-panel>
        </div>
        <ng-container *ngTemplateOutlet="matActionRow context:{disabled:getProductsDataForm.value.categories.length == 0}"></ng-container>


      </mat-expansion-panel>

      <!-- ** Brands ** -->
      <!-- [disabled]="step < 3" [hideToggle]="step < 3" -->
      <mat-expansion-panel [expanded]="step === 3"   (opened)="setStep(3)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Brands
          </mat-panel-title>
          <mat-panel-description *ngIf="!brandsSelected else panelDescriptionBrandsSelected" >
            Filter on specific Brands
            <!--            <mat-icon>account_circle</mat-icon>-->
          </mat-panel-description>
          <ng-template #panelDescriptionBrandsSelected>
            <mat-panel-description class="title">
              {{ getProductsDataForm.value.brands.length > 0 ? brandsChipElement.arrayString.join(', ') : "All brands selected" }}
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="spaceAround" >
          <button mat-raised-button type="button" color="primary" (click)="selectAllBrands()" >Select All Brands</button>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListBrands>
              <ng-container *ngTemplateOutlet="chip context: brandsChipElement"></ng-container>
              <input
                type="text"
                placeholder="Enter one or several brands..."
                #brandsInput
                [formControl]="brandsCtrl"
                [matChipInputFor]="chipListBrands"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event, brandsCtrl, brandsChipElement.arrayString, brandsChipElement.formArrayName, false)">
            </mat-chip-list>
          </mat-form-field>
        </div>
        <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!brandsSelected}"></ng-container>
      </mat-expansion-panel>


      <!-- ** Countries ** -->
      <!-- [disabled]="step < 4" [hideToggle]="step < 4" -->
      <mat-expansion-panel [expanded]="step === 4"   (opened)="setStep(4)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Countries of origin of the manufacturer
          </mat-panel-title>
          <mat-panel-description *ngIf="!countriesSelected else panelDescriptionCountriesSelected" >
            Filter on specific Countries
          </mat-panel-description>
          <ng-template #panelDescriptionCountriesSelected>
            <mat-panel-description >
              <span class="title">{{ getProductsDataForm.value.countries.length > 0 ? countriesChipElement.arrayString.join(', ') : "All countries selected" }}</span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="spaceAround">
          <button mat-raised-button type="button" color="primary" (click)="selectAllCountries()">Select All Countries</button>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListCountries >
              <ng-container *ngTemplateOutlet="chip context: countriesChipElement"></ng-container>
              <input
                #countriesInput
                placeholder="Countries..."
                [formControl]="countriesCtrl"
                [matAutocomplete]="autoCountries"
                [matChipInputFor]="chipListCountries"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoCountries="matAutocomplete" id="autoCountries" (optionSelected)="selected($event,countriesCtrl, countriesChipElement.arrayString, countriesChipElement.formArrayName, false)">
              <!--              <ng-container *ngTemplateOutlet="selectGroupsOptions context: test" ></ng-container>-->
              <mat-optgroup *ngFor="let group of possibleCountries" [label]="group.name"
                            [disabled]="group.disabled">
                <mat-option *ngFor="let list of group.list" [value]="list.value">
                  {{list.viewValue}}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!countriesSelected}"></ng-container>


      </mat-expansion-panel>


      <ng-container *ngIf="!basicSearch">
        <h2> Complex Search (based on specific ingredients or certificates)</h2>

        <!-- ** Contains At Least One of ** -->
        <!-- [disabled]="step < 5" [hideToggle]="step < 5" hideToggle-->
        <mat-expansion-panel [expanded]="step === 5"   (opened)="setStep(5)" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Contains At Least One
            </mat-panel-title>
            <mat-panel-description *ngIf="!containsAtLeastOneSelected else panelDescriptionContainsAtLeastOneDone" >
              Contains at least one of the following substance(s) or alert list(s)
            </mat-panel-description>
            <ng-template #panelDescriptionContainsAtLeastOneDone>
              <mat-panel-description>
                <p class="title" *ngIf="containsAtLeastOneSkip && getProductsDataForm.value.containAtLeastOne.INCIs.length == 0 && getProductsDataForm.value.containAtLeastOne.listsIds.length == 0 else panelDescriptionContainAtLeastOneSelection" > None, step skipped</p>
                <ng-template #panelDescriptionContainAtLeastOneSelection>
                  <p><!-- TODO need design in order to display the lists or part of the lists selected -->
                    <span *ngIf="getProductsDataForm.value.containAtLeastOne.INCIs.length > 0"> <span class="title"> INCIs:</span> Some INCIs selected! </span> <!--  {{ " "+ atLeastOneChipElement.arrayString.join(', ') }} -->
                    <span *ngIf="getProductsDataForm.value.containAtLeastOne.listsIds.length > 0"> <span class="title"> Alerts Lists:</span> Some Alerts list selected! </span> <!-- {{ " "+ alertListAtLeastOneChipElement.arrayString.join(', ') }} -->
                  </p>
                </ng-template>
              </mat-panel-description>
            </ng-template>
          </mat-expansion-panel-header>

          <div> <!-- button in a div so that the button is on his own line -->
            <button mat-raised-button type="button" color="primary" (click)="skipContainsAtLeastOne()">Skip this step</button>
          </div>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListINCIContainsOne >
              <ng-container *ngTemplateOutlet="chip context: atLeastOneChipElement"></ng-container>
              <input
                placeholder="Add INCI..."
                #inciAtLeastOneInput
                [formControl]="inciAtLeastOneCtrl"
                [matAutocomplete]="autoAtLeastOne"
                [matChipInputFor]="chipListINCIContainsOne"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoAtLeastOne="matAutocomplete" (optionSelected)="selected($event,inciAtLeastOneCtrl, atLeastOneChipElement.arrayString, atLeastOneChipElement.formArrayName, true)">
              <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
                {{INCI}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListAlertListsAtLeastOne >
              <ng-container *ngTemplateOutlet="chip context: alertListAtLeastOneChipElement"></ng-container>
              <input
                #alertListAtLeastOneInput
                placeholder="Alerts Lists..."
                [formControl]="alertListAtLeastOneCtrl"
                [matAutocomplete]="autoAlertListAtLeastOne"
                [matChipInputFor]="chipListAlertListsAtLeastOne"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoAlertListAtLeastOne="matAutocomplete" (optionSelected)="selected($event,alertListAtLeastOneCtrl, alertListAtLeastOneChipElement.arrayString, alertListAtLeastOneChipElement.formArrayName, false)">
              <mat-optgroup *ngFor="let group of possibleAlertsLists" [label]="group.name"
                            [disabled]="group.disabled">
                <mat-option *ngFor="let list of group.list" [value]="list.value">
                  {{list.viewValue}}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </mat-form-field>

          <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!containsAtLeastOneSelected}"></ng-container>

        </mat-expansion-panel>

        <!-- ** Contains All INCIs ** -->
        <!-- [disabled]="step < 6" [hideToggle]="step < 6" hideToggle-->
        <mat-expansion-panel [expanded]="step === 6"   (opened)="setStep(6)" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Contains All Substances
            </mat-panel-title>
            <mat-panel-description *ngIf="!containAllSelected else panelDescriptionContainAllDone" >
              Contains all of the following substance(s)
            </mat-panel-description>
            <ng-template #panelDescriptionContainAllDone>
              <mat-panel-description >
                <p class="title" *ngIf="containAllSkip && getProductsDataForm.value.containAll.INCIs.length == 0 else panelDescriptionContainsAllSelection" > None, step skipped</p>
                <ng-template #panelDescriptionContainsAllSelection>
                  <p><!-- TODO need design in order to display the lists or part of the lists selected -->
                    <span *ngIf="getProductsDataForm.value.containAll.INCIs.length > 0"> <span class="title"> INCIs:</span> Some INCIs selected! </span> <!--  {{ " "+ atLeastOneChipElement.arrayString.join(', ') }} -->
                  </p>
                </ng-template>
              </mat-panel-description>
            </ng-template>
          </mat-expansion-panel-header>

          <div class="spaceAround">
            <button mat-raised-button type="button" color="primary" (click)="skipContainsAll()">Skip this step</button>

            <mat-form-field class="chip-list">
              <mat-chip-list #chipListAllINCI >
                <ng-container *ngTemplateOutlet="chip context: allChipElement"></ng-container>
                <input
                  #inciAllInput
                  placeholder="Add INCI..."
                  [formControl]="inciAllCtrl"
                  [matAutocomplete]="autoAll"
                  [matChipInputFor]="chipListAllINCI"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
              </mat-chip-list>
              <mat-autocomplete #autoAll="matAutocomplete" (optionSelected)="selected($event,inciAllCtrl, allChipElement.arrayString, allChipElement.formArrayName, true)">
                <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
                  {{INCI}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>


          <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!containAllSelected}"></ng-container>

        </mat-expansion-panel>

        <!-- ** Exclude ** -->
        <!-- [disabled]="step < 7" [hideToggle]="step < 7"  hideToggle-->

        <mat-expansion-panel [expanded]="step === 7"   (opened)="setStep(7)" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Exclude
            </mat-panel-title>
            <mat-panel-description *ngIf="!excludeSelected else panelDescriptionExcludeDone" >
              Exclude the following substance(s) or alert list(s)
            </mat-panel-description>
            <ng-template #panelDescriptionExcludeDone>
              <mat-panel-description >
                <p class="title" *ngIf="excludeSkip && getProductsDataForm.value.exclude.INCIs.length == 0 && getProductsDataForm.value.exclude.listsIds.length == 0 else panelDescriptionExcludeSelection" > None, step skipped</p>
                <ng-template #panelDescriptionExcludeSelection>
                  <p><!-- TODO need design in order to display the lists or part of the lists selected -->
                    <span *ngIf="getProductsDataForm.value.exclude.INCIs.length > 0"> <span class="title"> INCIs:</span> Some INCIs excluded! </span> <!--  {{ " "+ atLeastOneChipElement.arrayString.join(', ') }} -->
                    <span *ngIf="getProductsDataForm.value.exclude.listsIds.length > 0"> <span class="title"> Alerts Lists:</span> Some Alerts list excluded! </span> <!-- {{ " "+ alertListAtLeastOneChipElement.arrayString.join(', ') }} -->
                  </p>
                </ng-template>
              </mat-panel-description>
            </ng-template>
          </mat-expansion-panel-header>

          <div> <!-- button in a div so that the button is on his own line -->
            <button mat-raised-button type="button" color="primary" (click)="skipExclude()">Skip this step</button>
          </div>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListExclude >
              <ng-container *ngTemplateOutlet="chip context: excludeChipElement"></ng-container>

              <input
                #inciExcludeInput
                placeholder="Add INCI..."
                [formControl]="inciExcludeCtrl"
                [matAutocomplete]="autoExclude"
                [matChipInputFor]="chipListExclude"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoExclude="matAutocomplete" (optionSelected)="selected($event,inciExcludeCtrl, excludeChipElement.arrayString, excludeChipElement.formArrayName, true)">
              <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
                {{INCI}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListAlertListsExclude >
              <ng-container *ngTemplateOutlet="chip context: alertListExcludeChipElement"></ng-container>
              <input
                #alertListExcludeInput
                placeholder="Alerts Lists..."
                [formControl]="alertListExcludeCtrl"
                [matAutocomplete]="autoAlertListExclude"
                [matChipInputFor]="chipListAlertListsExclude"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoAlertListExclude="matAutocomplete" (optionSelected)="selected($event,alertListExcludeCtrl, alertListExcludeChipElement.arrayString, alertListExcludeChipElement.formArrayName, false)">
              <mat-optgroup *ngFor="let group of possibleAlertsLists" [label]="group.name"
                            [disabled]="group.disabled">
                <mat-option *ngFor="let list of group.list" [value]="list.value">
                  {{list.viewValue}}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </mat-form-field>

          <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!excludeSelected}"></ng-container>

        </mat-expansion-panel>

        <!-- Metadata -->
        <!-- [disabled]="step < 8" [hideToggle]="step < 8"  hideToggle -->

        <mat-expansion-panel [expanded]="step === 8"  (opened)="setStep(8)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Metadatas
            </mat-panel-title>
            <mat-panel-description *ngIf="!metadatasSelected else panelDescriptionMetadatasSelected" >
              Filter on specific Metadatas, will retrieve products with only the selected metadata
              <!--            <mat-icon>account_circle</mat-icon>-->
            </mat-panel-description>
            <ng-template #panelDescriptionMetadatasSelected>
              <mat-panel-description class="title">
                {{ getProductsDataForm.value.metadatas.length > 0 ? getProductsDataForm.value.metadatas.join(', ') : "None, step skipped"}}
              </mat-panel-description>
            </ng-template>
          </mat-expansion-panel-header>
          <div class="spaceAround" id="metadatas">

            <button mat-raised-button type="button" color="primary" (click)="skipSelectMetadatas()">Skip this step</button>

            <mat-checkbox formArrayName="metadatas" *ngFor="let metadata of metadatas" (change)="onChangeMetadataCheckboxes(metadata,'metadatas', $event, true)" [checked]="metadata.checked"> {{metadata.name}} </mat-checkbox>
          </div>

          <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!metadatasSelected}"></ng-container>


        </mat-expansion-panel>

      </ng-container>

      <!-- ** ANALYSIS ** -->
      <mat-slide-toggle class="margin" (toggleChange)="toggleAnalysis()">  {{ analysisShowed ? 'Analysis added click here to remove it' : 'Add analysis of the products!' }} </mat-slide-toggle>

      <!-- [disabled]="step < 9"  hideToggle-->
      <mat-expansion-panel *ngIf="analysisShowed" [expanded]="step === 9" [hideToggle]="step < 9" (opened)="setStep(9)" >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Analysis
          </mat-panel-title>
          <mat-panel-description *ngIf="!analysisSelected else panelDescriptionAnalysisSelected" >
            Define how you want the products analysised, by alert list(s) and personal choice of INCI(s)
          </mat-panel-description>
          <ng-template #panelDescriptionAnalysisSelected>
            <mat-panel-description>
              <p class="title" *ngIf="containsAtLeastOneSkip && getProductsDataForm.value.analysis.personalList.length == 0 && getProductsDataForm.value.analysis.listsIds.length == 0 else panelDescriptionAnalysis" > None, step skipped</p>
              <ng-template #panelDescriptionAnalysis>
                <p><!-- TODO need design in order to display the lists or part of the lists selected -->
                  <span *ngIf="getProductsDataForm.value.analysis.personalList.length > 0"> <span class="title"> Personal INCIs:</span> Some INCIs selected! </span> <!--  {{ " "+ atLeastOneChipElement.arrayString.join(', ') }} -->
                  <span *ngIf="getProductsDataForm.value.analysis.listsIds.length > 0"> <span class="title"> Alerts Lists:</span> Some Alerts list selected! </span> <!-- {{ " "+ alertListAtLeastOneChipElement.arrayString.join(', ') }} -->
                </p>
              </ng-template>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="spaceAround">

          <button mat-raised-button type="button" color="primary" (click)="selectAllAnalysisList()" [disabled]="allAnalysisListSelected()"> {{allAnalysisListSelected() ? "All List Selected" : "Select All List"}}</button>

          <mat-form-field class="chip-list">
            <mat-chip-list #chipListAlertListsAnalysis >
              <ng-container *ngTemplateOutlet="chip context: alertListAnalysisChipElement"></ng-container>
              <input
                #alertListAnalysisInput
                placeholder="Alerts Lists..."
                [formControl]="alertListAnalysisCtrl"
                [matAutocomplete]="autoAlertListAnalysis"
                [matChipInputFor]="chipListAlertListsAnalysis"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
            </mat-chip-list>
            <mat-autocomplete #autoAlertListAnalysis="matAutocomplete" (optionSelected)="selected($event,alertListAnalysisCtrl, alertListAnalysisChipElement.arrayString, alertListAnalysisChipElement.formArrayName, false)">
              <mat-optgroup *ngFor="let group of possibleAlertsLists" [label]="group.name"
                            [disabled]="group.disabled">
                <mat-option *ngFor="let list of group.list" [value]="list.value">
                  {{list.viewValue}}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListINCIAnalysis >
            <ng-container *ngTemplateOutlet="chip context: inciAnalysisChipElement"></ng-container>

            <input
              #inciAnalysisInput
              placeholder="Personal list, add INCI..."
              [formControl]="inciAnalysisCtrl"
              [matAutocomplete]="autoINCIAnalysis"
              [matChipInputFor]="chipListINCIAnalysis"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #autoINCIAnalysis="matAutocomplete" (optionSelected)="selected($event,inciAnalysisCtrl, inciAnalysisChipElement.arrayString, inciAnalysisChipElement.formArrayName, true)">
            <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
              {{INCI}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context:{disabled:!analysisSelected}"></ng-container>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- basicSearch && !eanSelected -->
    <button mat-raised-button color="accent" type="submit" class="margin" [disabled]="!getProductsDataForm.valid ">Submit</button>
  </form>

  <button mat-raised-button color="primary" type="button" class="margin" (click)="usefulFunctionsService.downloadData(results, 'productsData')" [disabled]="!results">Download Results</button>

  <p *ngIf="results"><span class="title">Current products:</span> {{skip +" to " + currentMax }}</p>
  <p *ngIf="results && results.total"><span class="title">Total products found:</span> {{ results.total }}</p>

  <div>
    <button mat-raised-button color="accent" type="button" class="margin" (click)="getPreviousBatch()" [disabled]="!results || skip == 0">Get the previous {{limit}} products</button>
    <button mat-raised-button color="accent" type="button" class="margin" (click)="getNextBatch()" [disabled]="results  && results.total < limit || !results || results.length < limit">Get the next {{nextSkip}} products</button>
  </div>

  <div *ngIf="notFoundEAN.filteredData && notFoundEAN.filteredData.length > 0" id="notFoundEANs">

    <button mat-raised-button color="primary" type="button" class="margin" [disabled]="!results" (click)="toggleEANsNotFound()" >{{displayEANsNotFound ? "Hide" : "Show"}} EANs not found</button>

    <div *ngIf="displayEANsNotFound">
      <p><span class="title">EANs not found,</span> (either because not in the database or not corresponding to the form criterias):</p>

      <div class="mat-elevation-z8">

        <table mat-table class="widthMax" [dataSource]="notFoundEAN">

          <!-- Position Column -->
          <ng-container matColumnDef="EAN">
            <th mat-header-cell *matHeaderCellDef> EAN Not Found </th>
            <td mat-cell *matCellDef="let element"> {{element}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>


  <!-- TEMPLATES -->

  <!-- Chip Element -->
  <ng-template #chip let-arrayString="arrayString" let-formArrayName="formArrayName">
    <mat-chip
      *ngFor="let string of arrayString"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="chipListComponent.remove(string, arrayString,formArrayName, this.getProductsDataForm)">
      {{string}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
  </ng-template>

  <!--  Select Groups Option -->
  <!-- TODO Autocomplete don't detect the template outside of himself.... -->
  <ng-template #selectGroupsOptions let-possibleArray="possibleArray">
    <mat-optgroup *ngFor="let group of possibleArray" [label]="group.name"
                  [disabled]="group.disabled">
      <mat-option *ngFor="let list of group.list" [value]="list.value">
        {{list.viewValue}}
      </mat-option>
    </mat-optgroup>
  </ng-template>


  <!-- mat-expansion-panel-header -->
  <ng-template #matExpansionPanelHeader let-title="title" let-description="description">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{title}}
      </mat-panel-title>
      <mat-panel-description>
        {{description}}
        <!--            <mat-icon>account_circle</mat-icon>-->
      </mat-panel-description>
    </mat-expansion-panel-header>
  </ng-template>

  <!-- mat-action-row -->
  <ng-template #matActionRow let-firstStep="firstStep" let-disabled="disabled">
    <mat-action-row>
      <button *ngIf="!firstStep" mat-button color="warn" type="button" (click)="prevStep()">Previous</button>
      <button mat-button color="primary" type="button" [disabled]="disabled" (click)="nextStep()">Next</button>
    </mat-action-row>
  </ng-template>
</div>
